import { render, staticRenderFns } from "./NewPostPage.vue?vue&type=template&id=ca8e7f5c&"
import script from "./NewPostPage.vue?vue&type=script&lang=js&"
export * from "./NewPostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports